import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import PhoneAttendant from './pages/PhoneAttendant';
import Contact from './pages/Contact';
import Admin from './pages/Admin';
import SocialMedia from './pages/SocialMedia';
import WebsiteDesign from './pages/WebsiteDesign';
import About from './pages/About';
import SmartStart from './pages/SmartStart';
import BookConsultation from './pages/BookConsultation';
import Altam from './pages/Altam';
import Login from './pages/Login';
import AuthCallback from './components/AuthCallback';
import ProtectedRoute from './components/ProtectedRoute';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';

function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id during render (synchronous)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  // Show header/footer for all pages except login and auth callback
  const showLayout = !['/login'].includes(location.pathname);
  
  return (
    <>
      {showLayout && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/phone-attendant" element={<PhoneAttendant />} />
        <Route path="/social-media" element={<SocialMedia />} />
        <Route path="/website-design" element={<WebsiteDesign />} />
        <Route path="/about" element={<About />} />
        <Route path="/smartstart" element={<SmartStart />} />
        <Route path="/book-consultation" element={<BookConsultation />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/altam" element={<Altam />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/login" element={<Login />} />
        <Route 
          path="/admin" 
          element={
            <ProtectedRoute>
              <Admin />
            </ProtectedRoute>
          } 
        />
      </Routes>
      {showLayout && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </div>
  );
}

export default App;